



































import BaseTable from '../Common/Mixins/BaseTable.vue';
import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { networkSvc } from '@/services';
import { DataLoaderParams, NetworkDataLoaderParams } from '@/types';
import SearchBox from '@/components/Common/SearchBox.vue';

@Component({
  name: 'network-list',
  components: {
    SearchBox
  }
})
export default class NetworkList extends mixins(BaseTable) {
  title: string | null = 'Networks';
  dataKey: string = 'affiliateNetworks';
  sortBy: string = 'network_name';
  sortDesc: boolean = false;
  withDateRange: boolean = false;

  fields: object = {
    network_name: {
      label: 'Network Name',
      sortable: true,
      class: 'align-middle'
    },
    merchant_count: {
      label: 'Merchants',
      sortable: true,
      class: 'align-middle'
    },
    is_autoconfigured: {
      label: 'Auto Config',
      class: 'align-middle',
      formatter: (isAuto: boolean) => (isAuto ? 'Yes' : 'No')
    }
  };

  searchQuery: string = '';

  async dataLoader(params: DataLoaderParams): Promise<any> {
    const filters = {
      ...params.filters,
      searchByName: this.searchQuery || undefined
    };
    return networkSvc.getNetworks({
      ...params,
      filters
    } as NetworkDataLoaderParams);
  }

  onRowClicked(item: any): void {
    this.$router.push({
      name: 'networks-edit',
      params: {
        id: item[this.itemPK]
      }
    });
  }

  onSearchQueryChanged(searchQuery: string) {
    this.searchQuery = searchQuery;
    // @ts-ignore
    this.$refs.table.refresh();
  }
}
